export const QUERY_KEY = {
  geneCoverageData: 'geneCoverageData',
  panelToGenesMappingData: 'panelToGenesMappingData',
};
